import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Chart.js Module registrieren
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const getLast12MonthLabels = () => {
    const labels = [];
    const now = new Date();
    now.setDate(1); // Ensure we're on the 1st to avoid date rollover issues
    now.setMonth(now.getMonth() - 1); // Go to last full month
    const formatter = new Intl.DateTimeFormat('de-DE', { month: 'short', year: 'numeric' });
    for (let i = 11; i >= 0; i--) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
        labels.push(formatter.format(date));
    }
    return labels;
};

const getNext12MonthLabels = () => {
    const labels = [];
    const now = new Date();
    now.setDate(1); // Normalize to first of the month

    const formatter = new Intl.DateTimeFormat('de-DE', { month: 'short', year: 'numeric' });

    for (let i = 0; i < 12; i++) {
        const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
        labels.push(formatter.format(date));
    }

    return labels;
};

const getMonthLabelsForCurrentYear = () => {
    const labels = [];
    const year = new Date().getFullYear();

    const formatter = new Intl.DateTimeFormat('de-DE', {
        month: 'short',
        year: 'numeric'
    });

    for (let month = 0; month < 12; month++) {
        const date = new Date(year, month, 1);
        labels.push(formatter.format(date));
    }

    return labels;
};

const BarChart = ({
    solarProductionMonthly,
    feedInMonthly,
    gridSupplyMonthly
}) => {

    // console.log('solarProductionMonthly', solarProductionMonthly);
    // console.log('feedInMonthly', feedInMonthly);
    // console.log('gridSupplyMonthly', gridSupplyMonthly);

    const data = {
        labels: getMonthLabelsForCurrentYear(),
        datasets: [
            {
                label: 'Solarproduktion',
                data: solarProductionMonthly,
                backgroundColor: 'rgba(0, 164, 207, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
            {
                label: 'Netzeinspeisung',
                data: feedInMonthly,
                backgroundColor: 'rgba(3, 100, 127, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
            {
                label: 'Netzbezug',
                data: gridSupplyMonthly,
                backgroundColor: 'rgba(121, 180, 28, 1)',
                borderRadius: {
                    topLeft: 20, // Radius für obere linke Ecke
                    topRight: 20, // Radius für obere rechte Ecke
                },
            },
        ],
    };

    const options = {
        // maintainAspectRatio: false,
        devicePixelRatio: 4,
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 12, // Schriftgröße der X-Achse
                    },
                },
            },
            y: {
                ticks: {
                    font: {
                        size: 12, // Schriftgröße der Y-Achse (optional)
                    },
                    //callback: (value) => `${value} MWh`
                    callback: (value) => `${value} kWh`
                },
            },
        }
    };

    return <Bar data={data} options={options} />;
};

export default BarChart;
